"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ramda = require("ramda");

var _StyledSettingsComponents = require("./StyledSettingsComponents");

var _CurrentContext = _interopRequireDefault(require("../context/CurrentContext"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    opacity: 0;\n    cursor:pointer;\n    ::-webkit-file-upload-button {\n        cursor:pointer;\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var FileInput = _styledComponents.default.input(_templateObject());

var ImageLoader =
/*#__PURE__*/
function (_Component) {
  _inherits(ImageLoader, _Component);

  function ImageLoader() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ImageLoader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ImageLoader)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      error: false
    };

    _this.onLoad = function (e, fn) {
      var _this$props = _this.props,
          prop = _this$props.prop,
          postFileUrl = _this$props.postFileUrl;
      var file = (0, _ramda.head)(e.target.files);

      if (file) {
        if (postFileUrl) {
          var formData = new FormData();
          formData.append('file', file);
          fetch(postFileUrl, {
            method: 'POST',
            body: formData
          }).then(function (res) {
            return res.json();
          }).then(function (_ref) {
            var id = _ref.id;
            return fn(prop, id);
          }).catch(function () {
            _this.setState({
              error: true
            });

            setTimeout(function () {
              return _this.setState({
                error: false
              });
            }, 10000);
          });
        } else {
          var reader = new FileReader();
          reader.readAsDataURL(file);

          reader.onload = function () {
            return fn(prop, reader.result);
          };
        }
      }
    };

    _this.renderLoader = function (_ref2) {
      var current = _ref2.current,
          settings = _ref2.settings,
          onChangeProp = _ref2.onChangeProp,
          onChangeSettingsProp = _ref2.onChangeSettingsProp;
      var _this$props2 = _this.props,
          prop = _this$props2.prop,
          removable = _this$props2.removable;
      var item = current || settings;
      var fn = current ? onChangeProp : onChangeSettingsProp;
      return item[prop] && removable ? _react.default.createElement(_StyledSettingsComponents.PanelButton, {
        onClick: function onClick() {
          return fn(prop, null);
        }
      }, "\u0423\u0434\u0430\u043B\u0438\u0442\u044C") : _react.default.createElement(_StyledSettingsComponents.PanelButton, null, "\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C", _react.default.createElement(FileInput, {
        type: "file",
        accept: "image/*",
        onChange: function onChange(e) {
          return _this.onLoad(e, fn);
        }
      }));
    };

    return _this;
  }

  _createClass(ImageLoader, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_react.Fragment, null, _react.default.createElement(_CurrentContext.default.Consumer, null, this.renderLoader), this.state.error && _react.default.createElement("div", {
        style: {
          position: 'fixed',
          top: 15,
          right: 15,
          fontSize: 14,
          background: '#fff',
          fontFamily: 'Arial',
          padding: 15,
          zIndex: 1000,
          boxShadow: '0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05)'
        }
      }, "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0444\u0430\u0439\u043B"));
    }
  }]);

  return ImageLoader;
}(_react.Component);

exports.default = ImageLoader;
ImageLoader.propTypes = {
  prop: _propTypes.default.string,
  removable: _propTypes.default.bool,
  postFileUrl: _propTypes.default.string
};